<template>
  <div class="rpt-customer-structure">
    <div class="report-shell">
      <header class="report-header">
        <div class="header-row">
          <div>
            <h1>客户结构经营情况</h1>
            <p class="subtitle">按客户价值层级观察客户数量、收入贡献与客单价变化，识别客户结构优化方向。</p>
          </div>
          <div class="header-actions">
            <span class="report-badge"><i class="fa fa-clock-o"></i> 更新至 2026-07-24</span>
            <!-- <button type="button" class="analysis-button" @click="requestAnalysis"><i class="fa fa-magic"></i><span>智能分析</span></button> -->
          </div>
        </div>
      </header>

      <section class="kpi-grid">
        <article v-for="(kpi, i) in kpis" :key="i" class="kpi-card">
          <div class="kpi-label">{{ kpi.label }}</div>
          <div class="kpi-value" :style="{ color: toneColor(kpi.tone) }">{{ kpi.value }}</div>
          <div class="kpi-note">{{ kpi.note }}</div>
        </article>
      </section>

      <div class="customer-tables">
        <section class="table-card" v-for="(section, si) in sections" :key="si">
          <div class="table-card-head">
            <div>
              <div class="section-title"><i class="fa" :class="si === 0 ? 'fa-users' : 'fa-history'"></i><span>{{ section.title }}</span></div>
              <div class="section-note">收入单位：万元；{{ section.note }}</div>
            </div>
          </div>
          <div class="table-scroll">
            <table>
              <thead><tr><th>量级</th><th>客户数</th><th>数量占比</th><th>收入额</th><th>金额占比</th><th>客单价</th></tr></thead>
              <tbody>
                <tr v-for="(row, ri) in section.rows" :key="ri"><td class="tier-name">{{ row.tier }}</td><td>{{ num(row.count) }}</td><td class="share-value">{{ fmtPct(row.countShare) }}</td><td class="numeric">{{ num(row.revenue) }}</td><td class="share-value">{{ fmtPct(row.revenueShare) }}</td><td class="numeric">{{ num(row.unitPrice) }}</td></tr>
                <tr class="total-row"><td class="tier-name">总计</td><td>{{ num(section.total.count) }}</td><td class="share-value">100%</td><td class="numeric">{{ num(section.total.revenue) }}</td><td class="share-value">100%</td><td class="numeric">{{ num(section.total.unitPrice) }}</td></tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CustomerStructureReport',
  data() {
    return {
      sections: [],
      loading: false
    }
  },
  async created() {
    await this.fetchData()
  },
  computed: {
    currentSection() {
      if (!this.sections.length) return null
      return this.sections[0]
    },
    kpis() {
      var s = this.currentSection
      if (!s) {
        return [
          { label: 'H1 经营客户数', value: '—', note: '', tone: 'primary' },
          { label: 'H1 客户收入', value: '—', note: '', tone: 'positive' },
          { label: 'H1 平均客单价', value: '—', note: '', tone: 'positive' },
          { label: '收入集中度', value: '—', note: '', tone: 'warning' }
        ]
      }
      var total = s.total
      var qianwan = s.rows.find(function (r) { return r.tier === '千万级' }) || { count: 0, revenueShare: 0 }
      var baiwan = s.rows.find(function (r) { return r.tier === '百万级' }) || { revenueShare: 0 }
      var concentration = (qianwan.revenueShare + baiwan.revenueShare)
      var prevYear = String(Number(s.year) - 1)
      var prevSection = this.sections.find(function (sec) { return sec.year === prevYear })
      var unitPriceNote = ''
      var unitPriceTone = 'positive'
      if (prevSection && prevSection.total.unitPrice > 0) {
        var yoy = (total.unitPrice / prevSection.total.unitPrice - 1) * 100
        var arrow = yoy >= 0 ? '+' : ''
        unitPriceNote = '较' + prevYear + 'H1 ' + arrow + yoy.toFixed(1) + '%'
        unitPriceTone = yoy >= 0 ? 'positive' : 'negative'
      }
      return [
        { label: 'H1 经营客户数', value: this.num(total.count) + ' 家', note: '千万元级客户 ' + qianwan.count + ' 家', tone: 'primary' },
        { label: 'H1 客户收入', value: this.num(total.revenue) + ' 万', note: '千万元级贡献 ' + qianwan.revenueShare.toFixed(1) + '%', tone: 'positive' },
        { label: 'H1 平均客单价', value: this.num(total.unitPrice) + ' 万', note: unitPriceNote, tone: unitPriceTone },
        { label: '收入集中度', value: concentration.toFixed(1) + '%', note: '千万元级、百万元级客户贡献', tone: 'warning' }
      ]
    }
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        var res = await axios.post(
          'https://bigdata.cosmoplat.com/prod-api/system/api/call/cosmoplat/customer/revenueTier',
          { secret: '88py6X', paramList: [] },
          { headers: { 'Content-Type': 'application/json' }}
        )
        var data = (res.data && res.data.data) || []
        var grouped = {}
        data.forEach(function (item) {
          var y = item.year
          if (!grouped[y]) grouped[y] = []
          grouped[y].push({
            tier: item.tier || '—',
            count: Number(item.customer_count || 0),
            countShare: Number(item.count_ratio || 0),
            revenue: Number(item.revenue || 0),
            revenueShare: Number(item.revenue_ratio || 0),
            unitPrice: Number(item.atv || 0)
          })
        })
        var years = Object.keys(grouped).sort(function (a, b) { return Number(b) - Number(a) }).slice(0, 1)
        this.sections = years.map(function (y) {
          var rows = grouped[y]
          var totalCount = rows.reduce(function (s, r) { return s + r.count }, 0)
          var totalRevenue = rows.reduce(function (s, r) { return s + r.revenue }, 0)
          var totalUnitPrice = totalCount ? totalRevenue / totalCount : 0
          return {
            year: y,
            title: y + '年H1客户价值分布图',
            note: '客户价值按 H1 已确认收入分层。',
            rows: rows,
            total: { count: totalCount, revenue: totalRevenue, unitPrice: totalUnitPrice }
          }
        })
      } catch (e) {
        this.sections = []
      } finally {
        this.loading = false
      }
    },
    num(v) { return Math.round(Number(v || 0)).toLocaleString('zh-CN') },
    fmtPct(v) { return (Number(v || 0)).toFixed(1) + '%' },
    toneColor(t) { var m = { primary: '#4a5ff3', positive: '#0aa66a', warning: '#d98213', negative: '#e54b3d' }; return m[t] || '#4a5ff3' },
    requestAnalysis() {
      var s = this.currentSection
      window.parent.postMessage({ type: 'cosmo:business-report-analysis', report: { key: 'customer-structure', title: '客户结构经营情况', summary: s ? [(s.year) + '年H1经营客户' + this.num(s.total.count) + '家，实现收入' + this.num(s.total.revenue) + '万元，平均客单价' + this.num(s.total.unitPrice) + '万元。'] : ['暂无数据。'], risks: [], recommendations: [], data: { sections: this.sections }}}, window.location.origin)
    }
  }
}
</script>

<style lang="scss">
.rpt-customer-structure {
  height: 100%; min-height: 0; padding: 16px 20px;
  background: #eef3f9; overflow-y: auto;
  font-family: "PingFang SC", "HarmonyOS Sans SC", "Microsoft YaHei", -apple-system, BlinkMacSystemFont, sans-serif;
  color: #0f172a;
  scrollbar-width: thin; scrollbar-color: #fff transparent;

  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb { background: #fff; border-radius: 2px; }

  .report-shell { display: flex; height: 100%; max-width: 1600px; margin: 0 auto; flex-direction: column; }

  .report-header { position: relative; overflow: hidden; padding: 18px 22px; border: 1px solid rgba(148,163,184,.28); border-radius: 15px; background: linear-gradient(135deg,#ffffff,#f8fafc); box-shadow: 0 16px 38px rgba(15,23,42,.08); flex-shrink: 0; margin-bottom: 12px;
    &::after { content: ""; position: absolute; right: -80px; top: -100px; width: 260px; height: 260px; border-radius: 50%; background: radial-gradient(circle,rgba(74,95,243,.18),rgba(74,95,243,0) 68%); pointer-events: none; }
  }

  .header-row { position: relative; z-index: 1; display: flex; align-items: flex-start; justify-content: space-between; gap: 20px; }

  h1 { margin: 0 0 6px; font-size: 24px; line-height: 1.25; letter-spacing: -.02em; color: #0f172a; font-weight: 800; }

  .subtitle { margin: 0; color: #64748b; font-size: 13px; line-height: 1.5; }

  .header-actions { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }

  .report-badge { height: 34px; display: inline-flex; align-items: center; gap: 7px; padding: 0 13px; border-radius: 9px; border: 1px solid rgba(148,163,184,.28); background: #fff; color: #64748b; font-size: 12px; font-weight: 700; }

  .analysis-button { height: 34px; display: inline-flex; align-items: center; gap: 7px; padding: 0 14px; border-radius: 9px; border: none; background: linear-gradient(135deg,#4a5ff3,#2d7ff9); color: #fff; font-size: 12px; font-weight: 700; cursor: pointer; box-shadow: 0 7px 16px rgba(74,95,243,.2);
    &:hover { filter: brightness(1.08); }
  }

  .kpi-grid { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 10px; margin: 0 0 12px; flex-shrink: 0; }

  .kpi-card { position: relative; overflow: hidden; padding: 14px 16px; border: 1px solid rgba(148,163,184,.28); border-radius: 12px; background: #fff; box-shadow: 0 6px 16px rgba(15,23,42,.045);
    &::after { content: ""; position: absolute; right: -24px; bottom: -34px; width: 86px; height: 86px; border-radius: 50%; background: radial-gradient(circle,rgba(74,95,243,.1),transparent 70%); pointer-events: none; }
  }

  .kpi-label { font-size: 12px; color: #64748b; }
  .kpi-value { margin-top: 6px; font-size: 22px; font-weight: 850; letter-spacing: -.02em; }
  .kpi-note { margin-top: 3px; font-size: 10px; color: #64748b; }

  .customer-tables { display: grid; min-height: 0; gap: 12px; flex: 1; }
  // .customer-tables { display: grid; min-height: 0; grid-template-rows: repeat(2, minmax(0, 1fr)); gap: 12px; flex: 1; }

  .table-card { display: flex; overflow: hidden; border: 1px solid rgba(148,163,184,.28); border-radius: 15px; background: #fff; box-shadow: 0 16px 38px rgba(15,23,42,.08); flex-direction: column; }

  .table-card-head { padding: 12px 16px; border-bottom: 1px solid rgba(148,163,184,.28); flex-shrink: 0; }

  .section-title { display: flex; align-items: center; gap: 9px; font-size: 14px; font-weight: 800; color: #0f172a; }

  .section-note { margin-top: 4px; font-size: 11px; color: #64748b; }

  .table-scroll { min-height: 0; flex: 1; overflow: auto;
    table { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 11.5px; }
    thead th { position: sticky; top: 0; z-index: 2; padding: 8px 8px; color: #fff; background: #0d5fac; font-weight: 800; text-align: center; border-right: 1px solid rgba(148,163,184,.28); white-space: nowrap; }
    tbody td { padding: 8px 8px; border-right: 1px solid rgba(148,163,184,.28); border-bottom: 1px solid rgba(148,163,184,.28); text-align: center; white-space: nowrap; }
    th:last-child, td:last-child { border-right: 0; }
    tbody tr.total-row td { background: rgba(74,95,243,.08); font-weight: 850; }
    tbody tr:last-child td { border-bottom: 0; }
  }

  .tier-name { font-weight: 800; text-align: left !important; }
  .share-value { font-weight: 800; color: #4a5ff3; }
  .numeric { text-align: right !important; }
}
</style>
